import React from 'react';
import { Grid } from 'fw/forms';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import BusinessTypesDescriptionFormatter from 'areas/shared/components/formatter/BusinessTypesDescriptionFormatter';
import BusinessTypesVOBLink from 'areas/shared/components/formatter/BusinessTypesVOBLink';
import BusinessTypesSDVOBLink from 'areas/shared/components/formatter/BusinessTypesSDVOBLink';
import BusinessTypesTotalLink from 'areas/shared/components/formatter/BusinessTypesTotalLink';

const columns = [
	{ key: 'certificationStatusDescription', name: "SD/VOB Summary", width: 140, formatter: BusinessTypesDescriptionFormatter, getRowMetaData: (row) => row, sortable: false },
	{ key: 'activeVOBCount', name: "VOB", formatter: BusinessTypesVOBLink, getRowMetaData: (row) => row, sortable: false },
	{ key: 'activeSDVOBCount', name: "SDVOB", formatter: BusinessTypesSDVOBLink, getRowMetaData: (row) => row, sortable: false },
	{ key: 'total', name: "Total", formatter: BusinessTypesTotalLink, getRowMetaData: (row) => row, sortable: false }
];

class BusinessTypes extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = (props) => {
        return {
			list: []
		};
    }

    componentDidMount() {
		this.handleSearch();
    }

	handleSearch = (filters, callback) => {
        this.setState({
			list: []
        }, function () {
            this.search(null, callback);
        });
    }

	search = (opts, callback) => {
        const rq = Object.assign({}
		);

		var state = {
			list: []
		};

        new API().post(APIModules.Admin.url('/dashboard/getBusinessTypes'), rq,
            {
                success: (r) => {
					// Transform data to add total column and reorder rows
					const items = r.data.items || [];

					// Find specific rows
					const certified = items.find(x => x.certificationStatusDescription === "Certified") || { activeVOBCount: 0, activeSDVOBCount: 0 };
					const expired = items.find(x => x.certificationStatusDescription === "Expired") || { activeVOBCount: 0, activeSDVOBCount: 0 };
					const decertified = items.find(x => x.certificationStatusDescription === "Decertified") || { activeVOBCount: 0, activeSDVOBCount: 0 };
					const apps = items.find(x => x.certificationStatusDescription === "Apps") || { activeVOBCount: 0, activeSDVOBCount: 0 };
					const prequals = items.find(x => x.certificationStatusDescription === "PreQualification") || { activeVOBCount: 0, activeSDVOBCount: 0 };

					// Calculate totals row (sum of Certified, Expired, Decertified, Applications)
					const totalsVOB = certified.activeVOBCount + expired.activeVOBCount + decertified.activeVOBCount + apps.activeVOBCount;
					const totalsSDVOB = certified.activeSDVOBCount + expired.activeSDVOBCount + decertified.activeSDVOBCount + apps.activeSDVOBCount;

					// Calculate prequals total
					const prequalsTotal = prequals.activeVOBCount + prequals.activeSDVOBCount;

					// Calculate grand total
					const grandTotal = totalsVOB + totalsSDVOB + prequalsTotal;

					// Build transformed list with totals
					const transformedList = [
						{ id: 1, certificationStatusDescription: "Certified", activeVOBCount: certified.activeVOBCount, activeSDVOBCount: certified.activeSDVOBCount, total: certified.activeVOBCount + certified.activeSDVOBCount },
						{ id: 2, certificationStatusDescription: "Expired", activeVOBCount: expired.activeVOBCount, activeSDVOBCount: expired.activeSDVOBCount, total: expired.activeVOBCount + expired.activeSDVOBCount },
						{ id: 3, certificationStatusDescription: "Decertified", activeVOBCount: decertified.activeVOBCount, activeSDVOBCount: decertified.activeSDVOBCount, total: decertified.activeVOBCount + decertified.activeSDVOBCount },
						{ id: 4, certificationStatusDescription: "Applications", activeVOBCount: apps.activeVOBCount, activeSDVOBCount: apps.activeSDVOBCount, total: apps.activeVOBCount + apps.activeSDVOBCount },
						{ id: 5, certificationStatusDescription: "TOTALS", activeVOBCount: totalsVOB, activeSDVOBCount: totalsSDVOB, total: totalsVOB + totalsSDVOB },
						{ id: 6, certificationStatusDescription: "Prequals", activeVOBCount: null, activeSDVOBCount: null, total: prequalsTotal, isSpecialRow: true },
						{ id: 7, certificationStatusDescription: "TOTAL SD/VOB", activeVOBCount: null, activeSDVOBCount: null, total: grandTotal, isSpecialRow: true }
					];

					state = {
                        list: transformedList
                    };

					// Store search results
                    this.setState(state);

                    // Callback
                    if (callback)
                        callback();
                }
			});
			
			return state;
    }

	render() {
		return (
			<React.Fragment>
				<div className="business-types-grid">
					<Grid
						columns={columns}
						items={this.state.list}
						height={300}
						rowKey="id"
						name="default" />
				</div>
				<table className="dashboard-print-table business-types-print">
					<thead>
						<tr>
							<th>SD/VOB Summary</th>
							<th>VOB</th>
							<th>SDVOB</th>
							<th>Total</th>
						</tr>
					</thead>
					<tbody>
						{this.state.list.map((row, i) => (
							<tr key={i} className={row.certificationStatusDescription === 'TOTALS' || row.isSpecialRow ? 'print-totals-row' : ''}>
								<td>{row.certificationStatusDescription}</td>
								<td>{row.isSpecialRow ? '' : row.activeVOBCount}</td>
								<td>{row.isSpecialRow ? '' : row.activeSDVOBCount}</td>
								<td>{row.total}</td>
							</tr>
						))}
					</tbody>
				</table>
			</React.Fragment>
		)
	}
}

export default BusinessTypes;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminDashboard/businessTypes/BusinessTypes.js